import Cookies from 'js-cookie';
import { apiAction, logEntry } from '../utils/index';

import {
  GET_ALL_SEQUENCEVERSION_DETAILS,
  SEQUENCEVERSION_IS_LOADING,
  SEQUENCEVERSION_MANAGEMENT_ERROR,
  SET_SEQUENCEVERSION_CURRENT_PAGE,
  SET_SEQUENCEVERSION_DETAILS,
  SET_SEQUENCEVERSION_CHANGE,
  SET_SEQUENCEVERSION_FILTERED_RESULTS,
  SEQUENCEVERSION_CLEANUP,
  UPDATE_SEQUENCEVERSION_SAVE_STATUS,
  SET_SEQUENCEVERSIONFILE_CHANGE,
  SET_SEQUENCEVERSIONFILE_DETAILS,
  UPDATE_SEQUENCEVERSIONFILE_SAVE_STATUS,
  MULTIPLE_SEQUENCEVERSION_FILE_UPLOAD_STATUS

} from '../constants/index';

import { SEQUENCEVERSION_MANAGEMENT, UPDATE_SEQUENCEVERSION, CREATE_SEQUENCEVERSION } from '../constants/logs';

const envName = process.env.REACT_APP_ENV_NAME_SHORT;

//SequenceVersion Management
export const setSequenceVersionErrorThunk = err => dispatch => {
  let messageCode = err && err.response && err.response.data && err.response.data.errorMessage;
  messageCode = messageCode && messageCode.replace('[400]=>', '');
  dispatch(setSequenceVersionError(messageCode, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setSequenceVersionError(messageCode, false));
  }, 2500);
};

export const setSequenceVersionError = (messageCode, status) => {
  return {
    type: SEQUENCEVERSION_MANAGEMENT_ERROR,
    payload: {
      data: {
        isOpSuccessful: false,
        showBanner: status,
        isLoading: false,
        displayMessageCode: messageCode || ''
      }
    }
  };
};

export const getSequenceVersionThunk = (widgetCode, modelCategoryId, modelId) => dispatch => {
  let organisationId = Cookies.get(`selectedorganisationid-${envName}`) || 0;
  dispatch(getSequenceVersion(widgetCode, organisationId, modelCategoryId, modelId));
};

export const setLoadingStatus = isLoading => ({
  type: SEQUENCEVERSION_IS_LOADING,
  payload: { isLoading: isLoading }
});

export const getSequenceVersion = (widgetCode, organisationId, modelCategoryId, modelId) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/model/sequenceversion`,
    data: {
      OrganisationId: organisationId,
      ModelId: modelId,
      ModelCategoryId: modelCategoryId
    },
    method: 'GET',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setAllSequenceVersionListThunk(retData),
    onFailure: err => setSequenceVersionErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setAllSequenceVersionListThunk = data => dispatch => {
  let messageCode = data && data.message;
  let sequenceVersions = (data && data.retData && data.retData.SequenceVersions) || [];
  dispatch(setAllSequenceVersionList(messageCode, sequenceVersions));
};

export const setAllSequenceVersionList = (messageCode, sequenceVersions) => ({
  type: GET_ALL_SEQUENCEVERSION_DETAILS,
  payload: {
    data: {
      sequenceVersions: sequenceVersions,
      filteredResults: sequenceVersions,
      isLoading: false,
      duplicateSequence: false,
      displayMessageCode: messageCode,
      showBanner: false,
      isOpSuccessful: false
    }
  }
});

export const setCurrentPage = currentPage => ({
  type: SET_SEQUENCEVERSION_CURRENT_PAGE,
  payload: { currentPage }
});

export const saveSequenceVersionThunk = (sequenceVersion, widgetCode, filesTobeUploaded = []) => dispatch => {
  let url = '/management/model/sequenceversion/save';
  let actionName = sequenceVersion.SequenceVersionId === 0 ? CREATE_SEQUENCEVERSION : UPDATE_SEQUENCEVERSION;
  let log = logEntry(SEQUENCEVERSION_MANAGEMENT, actionName, sequenceVersion);

  dispatch(saveSequenceVersion(sequenceVersion, url, log, widgetCode, filesTobeUploaded));
};

export const saveSequenceVersion = (sequenceVersion, url, log, widgetCode, filesTobeUploaded) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}${url}`,
    method: 'POST',
    widgetcode: widgetCode,
    onLoad: status => setLoadingStatus(status),
    onSuccess: message => setSequenceVersionStatusThunk(message, sequenceVersion, filesTobeUploaded, widgetCode),
    onFailure: err => setSequenceVersionErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    data: {
      SequenceVersion: sequenceVersion,
      log: log
    }
  });

export const setSequenceVersionStatusThunk = (data, sequenceVersion, filesTobeUploaded, widgetCode) => async dispatch => {

  if (filesTobeUploaded != null && filesTobeUploaded.length > 0) {
    //There are file to be uploaded 
    //initiating upload
    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    let sequenceVersionId = data.SequenceVersionId || sequenceVersion.SequenceVersionId
    let ModelCategoryId = sequenceVersion.ModelCategoryId;
    let fileCount = 0
    for (const fileTobeUploaded of filesTobeUploaded) {
      fileCount++;
      let isLastFile = false
      if (fileCount == filesTobeUploaded.length) {
        isLastFile = true
      
      }
      fileTobeUploaded.IsLastFile = isLastFile
      fileTobeUploaded.ModelCategoryId = ModelCategoryId;
      fileTobeUploaded.UpdatedBy = sequenceVersion.UpdatedBy
      dispatch(saveMultipleSequenceVersionFileThunk(sequenceVersionId, fileTobeUploaded, widgetCode, isLastFile));
      await sleep(2000);
    }
    return;
  }

  dispatch(setSequenceVersionStatus(data.message, true));
  setTimeout(() => {
    //Hide the banner
    if (!data.SequenceVersionId) {
      dispatch(setSequenceVersionStatus('', false, sequenceVersion.IsCopy || false));
    } else {
      dispatch(setSequenceVersionInsertStatus(data.SequenceVersionId, false));
    }
  }, 2500);
};

export const setSequenceVersionInsertStatus = (sequenceVersionId, status) => ({
  type: UPDATE_SEQUENCEVERSION_SAVE_STATUS,
  payload: {
    data: {
      isOpSuccessful: true,
      showBanner: status,
      isLoading: false,
      displayMessageCode: '',
      sequenceVersionId: sequenceVersionId
    }
  }
});

export const setSequenceVersionStatus = (messageCode, status, fromCopy = false) => ({
  type: UPDATE_SEQUENCEVERSION_SAVE_STATUS,
  payload: {
    data: {
      isOpSuccessful: fromCopy ? false : true,
      showBanner: status,
      isLoading: false,
      displayMessageCode: messageCode || ''
    }
  }
});

export const describeSequenceVersionThunk = (modelCategoryId, sequenceVersionId, widgetCode) => dispatch => {
  dispatch(describeSequenceVersion(modelCategoryId, sequenceVersionId, widgetCode));
};

export const describeSequenceVersion = (modelCategoryId, sequenceVersionId, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/model/sequenceversion`,
    data: {
      SequenceVersionId: sequenceVersionId || undefined,
      ModelCategoryId: modelCategoryId
    },
    method: 'GET',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setdescribeSequenceVersionThunk(retData),
    onFailure: err => setSequenceVersionErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setdescribeSequenceVersionThunk = retData => dispatch => {
  dispatch(setDescribeSequenceVersion(retData));
};

export const setDescribeSequenceVersion = ({ retData }) => ({
  type: SET_SEQUENCEVERSION_DETAILS,
  payload: retData
});

export const setSequenceVersionChangeThunk = retData => dispatch => {
  dispatch(setSequenceVersionChange(retData));
};

export const setSequenceVersionChange = retData => ({
  type: SET_SEQUENCEVERSION_CHANGE,
  payload: retData
});

export const setFilteredDataThunk = retData => dispatch => {
  dispatch(setFilteredData(retData));
};

export const setFilteredData = retData => ({
  type: SET_SEQUENCEVERSION_FILTERED_RESULTS,
  payload: retData
});

export const sequenceVersionCleanUpThunk = sequenceVersion => dispatch => {
  dispatch(sequenceVersionCleanUp(sequenceVersion));
};

export const sequenceVersionCleanUp = sequenceVersion => ({
  type: SEQUENCEVERSION_CLEANUP,
  payload: {
    data: sequenceVersion
  }
});

//Sequence Version File Section
//************************* */

export const describeSequenceVersionFileThunk = (modelCategoryId, sequenceVersionId, sequenceVersionFileId, widgetCode) => dispatch => {
  dispatch(describeSequenceVersionFile(modelCategoryId, sequenceVersionId, sequenceVersionFileId, widgetCode));
};

export const describeSequenceVersionFile = (modelCategoryId, sequenceVersionId, sequenceVersionFileId, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/model/sequenceversion`,
    data: {
      SequenceVersionId: sequenceVersionId || undefined,
      SequenceVersionFileId: sequenceVersionFileId || undefined,
      ModelCategoryId: modelCategoryId
    },
    method: 'GET',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setdescribeSequenceVersionFileThunk(retData),
    onFailure: err => setSequenceVersionErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setdescribeSequenceVersionFileThunk = retData => dispatch => {
  dispatch(setDescribeSequenceVersionFile(retData));
};

export const setDescribeSequenceVersionFile = ({ retData }) => ({
  type: SET_SEQUENCEVERSIONFILE_DETAILS,
  payload: retData
});

export const setSequenceVersionFileChangeThunk = retData => dispatch => {
  dispatch(setSequenceVersionFileChange(retData));
};

export const setSequenceVersionFileChange = retData => ({
  type: SET_SEQUENCEVERSIONFILE_CHANGE,
  payload: retData
});

export const saveSequenceVersionFileThunk = (sequenceVersion, widgetCode) => dispatch => {
  let url = '/management/model/sequenceversion/save';
  let actionName = sequenceVersion.SequenceVersionId === 0 ? CREATE_SEQUENCEVERSION : UPDATE_SEQUENCEVERSION;
  let log = logEntry(SEQUENCEVERSION_MANAGEMENT, actionName, sequenceVersion);

  dispatch(saveSequenceVersionFile(sequenceVersion, url, log, widgetCode));
};

export const saveSequenceVersionFile = (sequenceVersion, url, log, widgetCode) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}${url}`,
    method: 'POST',
    widgetcode: widgetCode,
    onLoad: status => setLoadingStatus(status),
    onSuccess: message => setSequenceVersionFileStatusThunk(message),
    onFailure: err => setSequenceVersionErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    data: {
      SequenceVersion: sequenceVersion,
      log: log
    }
  });

export const setSequenceVersionFileStatusThunk = resp => dispatch => {
  dispatch(setSequenceVersionFileStatus(resp, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setSequenceVersionFileStatus('', false));
  }, 2500);
};

export const setSequenceVersionFileStatus = (messageCode, status) => ({
  type: UPDATE_SEQUENCEVERSIONFILE_SAVE_STATUS,
  payload: {
    data: {
      isOpSuccessful: true,
      showBanner: status,
      isLoading: false,
      displayMessageCode: messageCode || ''
    }
  }
});


//Multiple File Upload 
//Files will be uploaded  one after the other

export const setMultipleFileLoadingStatus = (status, message, sequenceVersion, isLastFile = false) => dispatch =>{
  if(status){
    dispatch(setLoadingStatus(status))
    dispatch(setMultipleFileUploadStatus(status, message, sequenceVersion, isLastFile))
  }

}

export const setMultipleFileUploadOperationDetails = (status, message, sequenceVersion, isLastFile = false) => dispatch => {
  dispatch(setMultipleFileUploadStatus(status, message, sequenceVersion))
  if (isLastFile) {
    dispatch(setSequenceVersionStatus('Upload complete', true));
    setTimeout(() => {
      //Hide the banner
      dispatch(setSequenceVersionInsertStatus(sequenceVersion.SequenceVersionId, false));
    }, 2500);
  }
}

export const setMultipleFileUploadStatus = (status, message, sequenceVersion) => ({
  type: MULTIPLE_SEQUENCEVERSION_FILE_UPLOAD_STATUS,
  payload: {
    data: {
      [sequenceVersion.Id]: {
        message: message,
        status: status
      }
    }
  }
})


export const saveMultipleSequenceVersionFileThunk = (sequenceVersionId, fileToBeUploaded, widgetCode, isLastFile = false) => dispatch => {
  let url = '/management/model/sequenceversion/save';
  let actionName = UPDATE_SEQUENCEVERSION;
  let log = logEntry(SEQUENCEVERSION_MANAGEMENT, actionName, fileToBeUploaded);
  let sequenceVersion = {
    SequenceVersionId: sequenceVersionId,
    ModelCategoryId: fileToBeUploaded.ModelCategoryId,
    Id: fileToBeUploaded.Id,
    SequenceFile: fileToBeUploaded
  }
  dispatch(saveMultipleSequenceVersionFile(sequenceVersion, url, log, widgetCode, isLastFile));
};


export const saveMultipleSequenceVersionFile = (sequenceVersion, url, log, widgetCode, isLastFile) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}${url}`,
    method: 'POST',
    widgetcode: widgetCode,
    onLoad: status => setMultipleFileLoadingStatus(status, "Uploading...", sequenceVersion),
    onSuccess: message => setMultipleFileUploadOperationDetails(true, 'Uploaded', sequenceVersion, isLastFile),
    onFailure: err => setMultipleFileUploadOperationDetails(false, `Upload Failed - ${err.toString()}`, sequenceVersion, isLastFile),
    accessToken: Cookies.get(`access-${envName}`),
    data: {
      SequenceVersion: sequenceVersion,
      log: log
    }
  });

export const setMultipleSequenceVersionFileStatusThunk = resp => dispatch => {
  dispatch(setSequenceVersionFileStatus(resp, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setSequenceVersionFileStatus('', false));
  }, 2500);
};

export const setMultipleSequenceVersionFileStatus = (messageCode, status) => ({
  type: UPDATE_SEQUENCEVERSIONFILE_SAVE_STATUS,
  payload: {
    data: {
      isOpSuccessful: true,
      showBanner: status,
      isLoading: false,
      displayMessageCode: messageCode || ''
    }
  }
});


